@if (modalData) {
  <pgh-modal-window size="md">
    <div modal-title>
      <h4><adp-label [labelKey]="modalData.headerKey"></adp-label></h4>
      <hr>
      </div>
      <div modal-body>
        @if (!!modalData.title) {
          <div class="text-center mb-20">
            {{modalData.title}}
          </div>
        } @else {
          @if (modalData.titleKey?.length) {
            <p class="mb-20 w-wrap">
              <adp-label [labelKey]="modalData.titleKey"></adp-label>
            </p>
          }
        }
        <div>
          @if (!!modalData.content) {
            <p class="mb-20 w-wrap">
              {{modalData.content}}
            </p>
          } @else {
            @if (modalData.contentKey?.length) {
              <p class="mb-20 w-wrap">
                <adp-label [labelKey]="modalData.contentKey"></adp-label>
              </p>
            }
          }
        </div>
        @if (!modalData.isProd && !!modalData.errorCode) {
          <div>
            <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Code_Label"></adp-label></b>
            {{modalData.errorCode}}
          </div>
        }
        @if (!modalData.isProd && !!modalData.errorMessage) {
          <div>
            <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Message_Label"></adp-label></b>
            {{modalData.errorMessage}}
          </div>
        }
        @if (!modalData.isProd && !!modalData.source) {
          <div>
            <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Source_Label"></adp-label></b>
            {{modalData.source}}
          </div>
        }
        @if (!!modalData.errorId) {
          <div>
            <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Id_Label"></adp-label></b>
            {{modalData.errorId}}
          </div>
        }
      </div>
      <div modal-footer>
        <button mat-flat-button color="accent" type="button" (click)="closeModal()">
          <adp-label [labelKey]="modalData.buttonTextKey"></adp-label>
        </button>
      </div>
    </pgh-modal-window>
  }
